module.exports = __webpack_public_path__ + "img/inventory-calendar.d8623ab7.svg";